import Vue from 'vue'
import Router from 'vue-router'
import * as Cookie from '../utils/cookie'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const constRoutes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      activeNav: 'home',
    },
    component: () => import('@/views/Home')
  },
  {
    path: '/whoweare',
    name: 'WhoWeAre',
    meta: {
      activeNav: 'whoweare',
      title: 'About us'
    },
    component: () => import('@/views/WhoWeAre')
  },
  {
    path: '/whatwedo/oursolutions/precisionengineering',
    name: 'precisionengineering',
    meta: {
      activeNav: 'whatwedo',
      title: 'Precision Engineering',
    },
    component: () => import('@/views/PrecisionEngineering'),
  },
  {
    path: '/whatwedo/oursolutions/opticalmachinevision',
    name: 'opticalmachinevision',
    meta: {
      activeNav: 'whatwedo',
      title: 'Optical Machine Vision',
    },
    component: () => import('../views/OpticalMachineVision/OpticalMachineVision'),
  },
  {
    path: '/whatwedo/oursolutions/opticalmachinevision/devicesandmodules',
    name: 'devicesandmodules',
    meta: {
      activeNav: 'whatwedo',
      title: 'Provision of optical vision devices and modules',
    },
    component: () => import('../views/OpticalMachineVision/DevicesAndModules'),
  },
  {
    path: '/whatwedo/oursolutions/opticalmachinevision/customized',
    name: 'customized',
    meta: {
      activeNav: 'whatwedo',
      title: 'Customized optical vision solutions',
    },
    component: () => import('../views/OpticalMachineVision/Customized'),
  },
  {
    path: '/whatwedo/oursolutions/opticalmachinevision/scenarios',
    name: 'scenarios',
    meta: {
      activeNav: 'whatwedo',
      title: 'High-precision visual inspection application scenarios',
    },
    component: () => import('../views/OpticalMachineVision/Scenarios'),
  },
  {
    path: '/whatwedo/oursolutions/semiconductor',
    name: 'semiconductor',
    meta: {
      activeNav: 'whatwedo',
      title: 'Semiconductor',
    },
    component: () => import('@/views/Semiconductor'),
  },
  {
    path: '/whatwedo/oursolutions/zeroclamp',
    name: 'zeroclamp',
    meta: {
      activeNav: 'whatwedo',
      title: 'Zero-Clamp Positioning Systems',
    },
    component: () => import('@/views/ZeroClamp/ZeroClamp'),
  },
  {
    path: '/whatwedo/oursolutions/zeroclamp/singlemodule',
    name: 'singlemodule',
    meta: {
      activeNav: 'whatwedo',
      title: 'Single-Module',
    },
    component: () => import('@/views/ZeroClamp/SingleModule'),
  },
  {
    path: '/whatwedo/oursolutions/zeroclamp/multimodule',
    name: 'multimodule',
    meta: {
      activeNav: 'whatwedo',
      title: 'Multi-Module',
    },
    component: () => import('@/views/ZeroClamp/MultiModule'),
  },
  {
    path: '/whatwedo/marketsectors',
    name:'marketsectors',
    meta: {
      activeNav: 'whatwedo',
      title: 'Market Sectors',
    },
    component: () => import('@/views/MarketSectors'),
  },
  {
    path: '/products/probestations',
    name:'probestations',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'Product Information',
    },
    component: () => import('@/views/Products/ProbeStations'),
  },
  {
    path: '/products/probestations/PXB-S',
    name:'PXB-S',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-S series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-S'),
  },
  {
    path: '/products/probestations/PXB-M',
    name:'PXB-M',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-M series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-M'),
  },
  {
    path: '/products/probestations/PXB-E',
    name:'PXB-E',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-E series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-E'),
  },
  {
    path: '/products/probestations/PXB-BE',
    name:'PXB-BE',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-BE series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-BE'),
  },
  {
    path: '/products/probestations/PXB-BET',
    name:'PXB-BET',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-BET series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-BET'),
  },
  {
    path: '/products/probestations/PXB-D',
    name:'PXB-D',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-D series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-D'),
  },
  {
    path: '/products/probestations/PXB-PL',
    name:'PXB-PL',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-PL Series Probe Stand (Customized)',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-PL'),
  },
  {
    path: '/products/probestations/PXB-VL',
    name:'PXB-VL',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-VL series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-VL'),
  },
  {
    path: '/products/probestations/PXB-SA',
    name:'PXB-SA',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'PXB-SA series probe station',
    },
    component: () => import('@/views/Products/ProbeStations/PXB-SA'),
  },
  {
    path: '/products/probestations/other',
    name:'PXB-other',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'Other Probe Stations, Analyzer and Probe Cards support',
    },
    component: () => import('@/views/Products/ProbeStations/Other'),
  },
  {
    path: '/products/probestations/easylink',
    name:'PXB-easylink',
    meta: {
      activeNav: 'products',
      activeSubNav: 'probestations',
      title: 'EasyLink system integration software',
    },
    component: () => import('@/views/Products/ProbeStations/EasyLink'),
  },
  {
    path: '/products/atetesting',
    name:'atetesting',
    meta: {
      activeNav: 'products',
      activeSubNav: 'atetesting',
      title: 'Product Introduction',
    },
    component: () => import('@/views/Products/ATETesting'),
  },
  {
    path: '/products/atetesting/ateboards',
    name:'ateboards',
    meta: {
      activeNav: 'products',
      activeSubNav: 'atetesting',
      title: 'ATE Instrument Boards',
    },
    component: () => import('@/views/Products/ATETesting/ATEBoards'),
  },
  {
    path: '/products/usilandlasers',
    name:'usilandlasers',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Product Information',
    },
    component: () => import('@/views/Products/UsiLandLasers'),
  },
  {
    path: '/products/usilandlasers/removaldevice',
    name:'removaldevice',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Laser Optronics Debris Removal Device',
    },
    component: () => import('@/views/Products/UsiLandLasers/RemovalDevice'),
  },
  {
    path: '/products/usilandlasers/Eagle-II',
    name:'Eagle-II',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Eagle-II',
    },
    component: () => import('@/views/Products/UsiLandLasers/Eagle-II'),
  },
  {
    path: '/products/usilandlasers/Eagle-II-Smart',
    name:'Eagle-II-Smart',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Eagle-II Smart',
    },
    component: () => import('@/views/Products/UsiLandLasers/Eagle-II-Smart'),
  },
  {
    path: '/products/usilandlasers/Eagle-V',
    name:'Eagle-V',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Eagle-V',
    },
    component: () => import('@/views/Products/UsiLandLasers/Eagle-V'),
  },
  {
    path: '/products/usilandlasers/Eagle-VI',
    name:'Eagle-VI',
    meta: {
      activeNav: 'products',
      activeSubNav: 'usilandlasers',
      title: 'Eagle-VI',
    },
    component: () => import('@/views/Products/UsiLandLasers/Eagle-VI'),
  },
  {
    path: '/news',
    name: 'news',
    meta: {
      activeNav: 'news',
      title: 'News',
    },
    component: () => import('@/views/News')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      activeNav: 'contact',
      title: 'Careers',
    },
    component: () => import('@/views/ContactUs')
  }
]

const routers = new Router({
  // mode: 'history',
  routes: constRoutes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

//进入页面之前判断用户是否登录
routers.beforeEach((to, from, next) => {
  // next()
  document.title = 'IntellMate'
  next()
})

export default routers



// WEBPACK FOOTER //
// ./src/router/index.js